import { apiClient } from "@game/api/ApiClient";

class TonDepositTracker {
  private pending = new Set<number>();
  private intervalId: number | null = null;

  track(depositId: number): void {
    this.pending.add(depositId);
    if (!this.intervalId) {
      this.intervalId = window.setInterval(() => this.poll(), 5000);
    }
  }

  untrack(depositId: number): void {
    this.pending.delete(depositId);
    if (this.pending.size === 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private async poll(): Promise<void> {
    for (const id of this.pending) {
      try {
        const status = await apiClient.getTonDepositStatus(id);

        if (status.status === "completed") {
          this.pending.delete(id);
          try { await apiClient.getMe(); } catch {}
          apiClient.emitHardBalanceUpdate();

          const tg = (window as any).Telegram?.WebApp;
          try {
            tg?.showPopup?.({
              title: "Payment received",
              message: "Your TON payment has been confirmed!",
              buttons: [{ type: "ok" }],
            });
          } catch {
            try {
              tg?.showAlert?.("Your TON payment has been confirmed!");
            } catch {}
          }
        } else if (status.status === "expired") {
          this.pending.delete(id);
        }
      } catch {
        // continue polling
      }
    }

    if (this.pending.size === 0 && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

export const tonDepositTracker = new TonDepositTracker();
